export enum CommonMessageType {
  GET_APP_TYPE = 'get-app-type',
  GET_CURRENT_INSTANCE = 'get-current-instance',
  DELETE_LOGIN_CREDENTIALS = 'delete-login-credentials',
  GET_LOGIN_CREDENTIALS = 'get-login-credentials',
  SAVE_LOGIN_CREDENTIALS = 'save-login-credentials',
  REQUEST_INSTANCES = 'request-instances',
  INSTANCE_SELECTION = 'instance-selection',
  INSTANCE_SELECTED = 'instance-selected',
  SWITCH_INSTANCE = 'switch-instance',
  LOAD_INSTANCE_SELECTOR = 'load-instance-selector',
  SET_USER_LANGUAGE = 'set-user-language',
  GET_USER_LANGUAGE = 'get-user-language',
  CLEAR_ELECTRON_COOKIES = 'clear-electron-cookies',
}

export enum AppType {
  WEB_BROWSER = 'web-browser',
  LEXIAN_BROWSER = 'lexian-browser',
  LEXIAN_TIME_TRACKER = 'lexian-time-tracker',
}

export type CommonMessageResponse = {
  [CommonMessageType.GET_LOGIN_CREDENTIALS]: string;
  [CommonMessageType.DELETE_LOGIN_CREDENTIALS]: null;
  [CommonMessageType.REQUEST_INSTANCES]: string[];
  [CommonMessageType.GET_CURRENT_INSTANCE]: {url?: string; name?: string};
  [CommonMessageType.GET_USER_LANGUAGE]: string;
  [CommonMessageType.SWITCH_INSTANCE]: boolean;
  [CommonMessageType.GET_APP_TYPE]: AppType;
  [CommonMessageType.INSTANCE_SELECTION]: {url?: string; name?: string};
};

export type InstanceMessage =
  | {
      payload: null;
      type: CommonMessageType.INSTANCE_SELECTION;
    }
  | {
      payload:
        | {
            url: string;
            name?: string | undefined;
          }
        | undefined;
      type: CommonMessageType.INSTANCE_SELECTED;
    }
  | {
      payload: {
        url: string;
        name?: string | undefined;
      };
      type: CommonMessageType.SWITCH_INSTANCE;
    }
  | {
      payload: null;
      type: CommonMessageType.GET_CURRENT_INSTANCE;
    };

export type LanguageMessage =
  | {
      type: CommonMessageType.GET_USER_LANGUAGE;
      payload: null;
    }
  | {
      type: CommonMessageType.SET_USER_LANGUAGE;
      payload: string;
    };

export type CommonMessage =
  | {
      payload: {username: string};
      type: CommonMessageType.DELETE_LOGIN_CREDENTIALS;
    }
  | {payload: null; type: CommonMessageType.GET_APP_TYPE}
  | {
      type: CommonMessageType.REQUEST_INSTANCES;
      payload: null;
    }
  | {
      type: CommonMessageType.LOAD_INSTANCE_SELECTOR;
      payload: null;
    }
  | {
      type: CommonMessageType.SAVE_LOGIN_CREDENTIALS;
      payload: {
        username: string;
        password: string | null;
      };
    }
  | {
      type: CommonMessageType.GET_LOGIN_CREDENTIALS;
      payload?: string;
    }
  | {
      type: CommonMessageType.CLEAR_ELECTRON_COOKIES;
      payload: null;
    }
  | LanguageMessage
  | InstanceMessage;

export type OnlyCertainTyped<T, U> = T extends {type: U} ? T : never;

export type CommonMessageForResponse = OnlyCertainTyped<
  CommonMessage,
  CommonMessageType & keyof CommonMessageResponse
>;

export enum WindowFrameName {
  OAUTH2_POPUP = 'OAuth2 Popup',
}
